import React, { Component } from 'react'
import { Link, NavLink } from 'react-router-dom'
import logo from '../../images/logo.png'
import RightSvg from '../icons/RightSvg'
import HamburgerSvg from '../icons/HamburgerSvg'

export class Nav extends Component {
    state = {
        inpRef: React.createRef()
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener("click", this.handleClickOutside);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("click", this.handleClickOutside);
    }

    handleScroll = () => {
        if (window.scrollY >= 50) {
            const nav = document.querySelector('.navbar');
            nav.style.position = 'fixed';
            nav.style.top = '0px';
        } else {
            const nav = document.querySelector('.navbar');
            nav.style.position = 'inherit';
        }
    }

    handleClickOutside = (event) => {
        if (this.state.inpRef.current && !this.state.inpRef.current.contains(event.target) && !document.querySelector('.lbl-resp').contains(event.target)) {
            this.closeNav(this.state.inpRef);
        }
    }

    closeNav = (inpRef) => {
        if (inpRef?.current) {
            inpRef.current.checked = false;
        }
    }

    render() {
        const { inpRef } = this.state;

        return (
            <div className=' bg-[#fff]  navbar w-full z-[900]' >
                <div className='container flex justify-between items-center p-[10px_0px]  '>

                    <Link to="/">
                        <img className='w-[200px] h-[85px]' src={logo} />
                    </Link>

                    <div className='menu max-[1100px]:w-[32px]'>
                        <input ref={inpRef} type='checkbox' id='onclick' className=' inp_check' />
                        <label htmlFor='onclick' className='lbl-resp'>
                            <HamburgerSvg />
                        </label>

                        <ul className='flex navlist items-center gap-[30px]'>
                            <li className='font-[500] text-[18px] text-[#212529] list  '>
                                <NavLink onClick={() => this.closeNav(inpRef)} to="/">Ana səhifə</NavLink>
                            </li>

                            <li className='font-[500] text-[18px] text-[#212529] list '>
                                <NavLink onClick={() => this.closeNav(inpRef)} to="/about-us">Haqqımızda</NavLink>
                            </li>

                            {/* <li className='font-[500] text-[18px] text-[#212529] list '>
                                <NavLink onClick={() => this.closeNav(inpRef)} to="/project">Portfolio</NavLink>
                            </li> */}

                            <li className='font-[500] text-[18px] text-[#212529] list '>
                                <NavLink onClick={() => this.closeNav(inpRef)} to="/services">Xidmətlərimiz</NavLink>
                            </li>
                            <li className='font-[500] text-[18px] text-[#212529] list '>
                                <NavLink onClick={() => this.closeNav(inpRef)} to="/blogs">Bloq</NavLink>
                            </li>
                            <li className='font-[500] text-[18px] text-[#212529] list '>
                                <NavLink onClick={() => this.closeNav(inpRef)} to="/contact-us">Əlaqə</NavLink>
                            </li>
                            <li className=' teklif '>
                                <NavLink to="/contact-us" className='bg-[#0E38B1] text-[#fff] font-[500] text-[18px]  p-[14px_16px] rounded-[8px] flex items-center gap-[8px]  max-[1100px]:p-[7px_8px] max-[1100px]:text-[px]  '>
                                    Qiymət təklifi al

                                    <RightSvg fill="#fff" height="22" width="22" />
                                </NavLink>
                            </li>
                        </ul>
                    </div>



                    <NavLink to="/contact-us" className='bg-[#0E38B1] text-[#fff] text-[18px] font-[500] p-[14px_16px] rounded-[8px] flex items-center gap-[8px] max-[1101px]:hidden '>
                        Qiymət təklifi al

                        <RightSvg fill="#fff" height="22" width="22" />
                    </NavLink>
                </div>
            </div>

        )
    }
}

export default Nav